import BidAndBuyNowBlock from './bids-and-buynow-block';
export default BidAndBuyNowBlock;